import React, { useCallback } from "react";

import { formatBytes, formatBytesPerSec, estimatedTime } from "utils";
import { CONTENT } from "consts";

function Volumes(props) {
  let status = {
    loadInfo: null,
    percentage: null,
    storageETA: null,
    speed: null,
    msg: null
  };

  const volume = props.volume;

  const getInfo = useCallback(
    volume => {
      switch (props.volStatusKey) {
        case "ESTIMATING":
        case "PENDING":
          return {
            loadInfo: "", //"0 %"
            percentage: 0,
            storageETA:
              props.type === "backup"
                ? "Backup size: " + formatBytes(volume.size)
                : "ETA - " +
                  estimatedTime(
                    volume.size - volume.restoredSize,
                    volume.speed
                  ),
            speed: null,
            msg: !props.pausedStatus ? (
              <div className="vll_item__content__subitem_status vll_waiting">
                {CONTENT.progressStatuses.waiting}
              </div>
            ) : (
              <div className="vll_item__content__subitem_status vll_inprogress">
                {CONTENT.progressStatuses.paused}
              </div>
            )
          };
        case "SUCCESS":
          return {
            loadInfo: "100 %",
            percentage: 100,
            storageETA:
              formatBytes(volume.size) +
              " of " +
              formatBytes(volume.size) +
              " used",
            speed: null,
            msg: (
              <div className="vll_item__content__subitem_status vll_done"></div>
            )
          };
        case "CANCELLED":
        case "PAUSED":
        case "IN_PROGRESS":
        case "FAILURE":
          if (props.type === "backup")
            return {
              loadInfo:
                volume.backedupSize &&
                formatBytes(volume.backedupSize) +
                  "/" +
                  formatBytes(volume.size) +
                  " (" +
                  volume.progress +
                  "%)",
              percentage: volume.progress ? volume.progress : "0",
              storageETA: !props.pausedStatus
                ? "ETA - " +
                  estimatedTime(volume.size - volume.backedupSize, volume.speed)
                : "Backup size: " + formatBytes(volume.size),
              speed: !props.pausedStatus
                ? "Speed - " +
                  (volume.speed ? formatBytesPerSec(volume.speed) : "0")
                : "",
              msg: !props.pausedStatus ? (
                <div className="vll_item__content__subitem_status vll_inprogress">
                  {CONTENT.progressStatuses.inProgress}
                </div>
              ) : (
                <div className="vll_item__content__subitem_status vll_inprogress">
                  {CONTENT.progressStatuses.paused}
                </div>
              )
            };
          else
            return {
              loadInfo:
                volume.restoredSize &&
                formatBytes(volume.restoredSize) +
                  "/" +
                  formatBytes(volume.size) +
                  " (" +
                  volume.progress +
                  "%)",
              percentage: volume.progress ? volume.progress : "0",
              storageETA:
                "ETA - " +
                estimatedTime(volume.size - volume.restoredSize, volume.speed),
              speed:
                "Speed - " +
                (volume.speed ? formatBytesPerSec(volume.speed) : "0"),
              msg: (
                <div className="vll_item__content__subitem_status vll_inprogress">
                  {CONTENT.progressStatuses.inProgress}
                </div>
              )
            };
        case "PREPARING":
        case "PENDING":
        case "ONGOING":
          return {
            loadInfo:
              volume.restoredSize &&
              formatBytes(volume.restoredSize) +
                "/" +
                formatBytes(volume.size) +
                " (" +
                volume.progress +
                "%)",
            percentage: volume.progress ? volume.progress : "0",
            storageETA:
              "ETA - " +
              estimatedTime(volume.size - volume.restoredSize, volume.speed),
            speed:
              "Speed - " +
              (volume.speed ? formatBytesPerSec(volume.speed) : "0"),
            msg: (
              <div className="vll_item__content__subitem_status vll_inprogress">
                {CONTENT.progressStatuses.inProgress}
              </div>
            )
          };
        default:
          break;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [volume]
  );

  status = getInfo(volume);

  return (
    <div className={"vll_item__content__subitem vll_subitem_" + (props.k + 1)}>
      <div className="vll_item__content__subitem_icon"></div>
      <div className="vll_item__content__subitem_info">
        <div className="drive_loader_info">
          <div className="dl__name">
            {(volume.label ? volume.label : CONTENT.restore.image.volumesList) +
              " (" +
              volume.drive +
              ":)"}
          </div>
          <div className="dl__loader">{status?.loadInfo}</div>
        </div>
        <div className="subitem_info__storage">
          <span
            className="subitem_info__storage__line"
            style={{ width: status?.percentage + "%" }}
          />
        </div>
        <div className="pc_storage_data">
          <p>{status?.storageETA}</p>
          <p>{status?.speed}</p>
        </div>
      </div>
      {status?.msg}
    </div>
  );
}

export default Volumes;
